// The registered address country of a company's contract terms (tasks#211): a choice from the ISO 3166-1
// countries, stored as the English country name (the column has always held free text), United Kingdom first.

const UNITED_KINGDOM = 'United Kingdom'

// ISO 3166-1 alpha-2, without GB (it goes first)
const CODES = (
    'AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV ' +
    'BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ' +
    'ET FI FJ FK FM FO FR GA GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL ' +
    'IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA ' +
    'MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ ' +
    'OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN ' +
    'SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG ' +
    'VI VN VU WF WS YE YT ZA ZM ZW'
).split(' ')

// stored spellings that mean a listed country (prod 2026-11-04: "UK" 18 times, a few typos)
const ALIASES = {
    uk: UNITED_KINGDOM,
    gb: UNITED_KINGDOM,
    'great britain': UNITED_KINGDOM,
    england: UNITED_KINGDOM,
    scotland: UNITED_KINGDOM,
    wales: UNITED_KINGDOM,
    'northern ireland': UNITED_KINGDOM,
    'united kingdon': UNITED_KINGDOM,
    'united kingdrom': UNITED_KINGDOM,
    'united kindgdom': UNITED_KINGDOM,
    'united kindrom': UNITED_KINGDOM,
    us: 'United States',
    usa: 'United States',
    'united states of america': 'United States',
}

let names = null

function countryNames() {
    if (!names) {
        const display = new Intl.DisplayNames(['en'], { type: 'region' })
        names = CODES.map((code) => display.of(code)).sort((a, b) =>
            a.localeCompare(b, 'en')
        )
    }
    return names
}

// a stored value as the listed name it means; any other value is kept as it is
export function normalizeCountry(value) {
    if (typeof value !== 'string' || !value.trim()) return value
    const key = value.trim().toLowerCase()
    if (ALIASES[key]) return ALIASES[key]
    const listed = [UNITED_KINGDOM, ...countryNames()].find(
        (name) => name.toLowerCase() === key
    )
    return listed || value
}

// the select's items: United Kingdom, then every other country A–Z; a stored value that is no country
// stays selectable, so loading the form never drops it
export function countryOptions(current) {
    const options = [UNITED_KINGDOM, ...countryNames()]
    if (current && !options.includes(current)) options.unshift(current)
    return options.map((name) => ({ title: name, value: name }))
}
